import React from 'react';
import PropTypes from 'prop-types';

import TextField from './TextField';
import styles from './FormTextField.scss';

export default function FormTextField(props) {
  const { error, ...restProps } = props;

  return (
    <>
      <TextField error={error && error.length} {...restProps} />
      <span className={styles.error}>{error}</span>
    </>
  );
}

FormTextField.propTypes = {
  error: PropTypes.string,
};

FormTextField.defaultProps = {
  error: null,
};



// WEBPACK FOOTER //
// ./src/components/controls/FormTextField.jsx